import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Mail, Clock, Instagram } from 'lucide-react';

export default function Footer() {
  return (
    <footer style={{ backgroundColor: '#2A3630', color: '#E2E8F0' }} data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <h3
              className="text-3xl font-bold mb-4"
              style={{ fontFamily: '"Barlow", sans-serif', color: '#E2E8F0' }}
            >
              Grainette
            </h3>
            <p className="text-sm text-gray-400 leading-relaxed mb-4">
              Bar à Salade & Fabrique à Pâtes.<br />
              Des compositions fraîches & savoureuses au cœur de Paris 9e.
            </p>
            <div className="flex gap-3 mt-4">
              <a
                href="https://www.instagram.com/grainette75/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center w-9 h-9 rounded-full transition-colors"
                style={{ backgroundColor: 'rgba(128,168,144,0.2)' }}
                data-testid="footer-instagram"
              >
                <Instagram size={16} style={{ color: '#80a890' }} />
              </a>
            </div>
          </div>

          {/* Adresses */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4" style={{ color: '#80a890' }}>
              Nos Adresses
            </h4>
            <ul className="space-y-4 text-sm text-gray-400">
              <li>
                <div className="flex items-start gap-2">
                  <MapPin size={14} className="mt-0.5 shrink-0" style={{ color: '#80a890' }} />
                  <div>
                    <p className="text-gray-200 font-medium">Bar à Salade – Mogador</p>
                    <p>27 rue de Mogador, 75009 Paris</p>
                  </div>
                </div>
              </li>
              <li>
                <div className="flex items-start gap-2">
                  <MapPin size={14} className="mt-0.5 shrink-0" style={{ color: '#80a890' }} />
                  <div>
                    <p className="text-gray-200 font-medium">Bar à Salade – Godot de Mauroy</p>
                    <p>16 rue Godot de Mauroy, 75009 Paris</p>
                  </div>
                </div>
              </li>
              <li>
                <div className="flex items-start gap-2">
                  <MapPin size={14} className="mt-0.5 shrink-0" style={{ color: '#EEB52D' }} />
                  <div>
                    <p className="text-gray-200 font-medium">Fabrique à Pâtes</p>
                    <p>17 rue Godot de Mauroy, 75009 Paris</p>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          {/* Horaires */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4" style={{ color: '#80a890' }}>
              Horaires
            </h4>
            <div className="space-y-2 text-sm text-gray-400">
              <div className="flex items-center gap-2">
                <Clock size={14} style={{ color: '#80a890' }} />
                <span>Lundi – Vendredi</span>
              </div>
              <p className="text-gray-200 pl-5">Salades · 11h30 – 15h00</p>
              <p className="text-gray-200 pl-5">Pâtes · 11h30 – 14h30</p>
              <p className="text-gray-500 text-xs pl-5 mt-2">Fermé le week-end</p>
            </div>
            <div className="mt-6 space-y-2 text-sm text-gray-400">
              <div className="flex items-center gap-2">
                <Mail size={14} style={{ color: '#80a890' }} />
                <a href="mailto:contact@grainette.fr" className="hover:text-white transition-colors">contact@grainette.fr</a>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4" style={{ color: '#80a890' }}>
              Navigation
            </h4>
            <ul className="space-y-2 text-sm text-gray-400">
              {[
                { label: "Menu Salades", to: "/menus-salades" },
                { label: "Menu Pâtes", to: "/menus-pates" },
                { label: "Nos Adresses", to: "/ou-nous-trouver" },
                { label: "Allergènes", to: "/allergenes" },
                { label: "Recrutement", to: "/recrutement" },
                { label: "Contact", to: "/contact" },
                { label: "Mentions légales", to: "/mentions-legales" },
              ].map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="hover:text-white transition-colors"
                    data-testid={`footer-link-${link.to.replace('/', '')}`}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-gray-500" style={{ borderColor: 'rgba(255,255,255,0.08)' }}>
          <p>© {new Date().getFullYear()} Grainette – SAS BARLES. Tous droits réservés.</p>
          <Link to="/mentions-legales" className="hover:text-gray-400 transition-colors">
            Mentions légales
          </Link>
        </div>
      </div>
    </footer>
  );
}
